import React from "react";
import { useParams, useNavigate } from "react-router-dom";

import routes from "constants/routes";
import { mapCouponToFormValues } from "utils/couponUtils";
import { mapCouponDetailsFromApi } from "helpers/couponApi";
import { formatApiErrorForDisplay } from "helpers/packageManagementApi";
import { useCouponDetails } from "store/backend/apiHooks";
import { Loader } from "widgets";

import CouponForm from "./CouponForm";
import styles from "./CouponsList.module.scss";

const ViewCoupon = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    data: couponDetails,
    isLoading,
    isError,
    error,
  } = useCouponDetails(id);

  if (isLoading) {
    return (
      <div className={styles.emptyState}>
        <Loader />
      </div>
    );
  }

  if (isError || !couponDetails) {
    return (
      <div className={styles.emptyState}>
        <p>{formatApiErrorForDisplay(error, "Failed to load coupon details.")}</p>
        <button
          type="button"
          className={styles.createButton}
          onClick={() => navigate(routes.coupons.list)}
        >
          Back to Coupons
        </button>
      </div>
    );
  }

  const initialValues = mapCouponToFormValues(
    mapCouponDetailsFromApi(couponDetails)
  );

  const formKey = [
    id,
    couponDetails.modified_date,
    couponDetails.validity?.expiry_date,
  ].join("-");

  return <CouponForm key={formKey} mode="view" initialValues={initialValues} />;
};

export default ViewCoupon;
